import Grid from "@mui/material/Grid";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import { Divider } from "@mui/material";
import SignIn from "../components/login/UserLogin";


function Login() {
    return (
        <Grid container>
            <Header />
            <Divider orientation="horizontal" sx={{ width:'100%'}}/>
            <Grid container>
                <SignIn />    
            </Grid>        
            <Footer />
        </Grid>
    );

}

export default Login;